<template>
  <div>
    <Hero />
    <div class="pt-6">
      <Taxon v-for="taxon in taxons_filtered" :key="taxon.id" :taxon="taxon" />
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import Hero from "@/components/knowledge/Hero";
import Taxon from "@/components/knowledge/Taxon";

export default {
    name: "Index",
    methods: mapActions({"fetch": "knowledge/taxons/fetchTaxons"}),
    computed: {
        taxons_filtered() {
            return this.taxons.filter(taxon => {
                return taxon.articles_count > 0 || taxon.children_count > 0;
            });
        },
        ...mapGetters({"taxons": "knowledge/taxons/taxons"})
    },
    mounted() {
        this.fetch();
    },
    components: { Hero, Taxon }
};
</script>
<style>
.bb-view-background {
  background: var(--knowledge-background);
}
</style>
